<template>
    <rkm-area
        no-margin-top
        title="Observações da pós-consulta"
    >
        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.observacoes"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>